import React, { useState } from 'react';
import { API_BASE_URL } from '../../config';

function DeclarationStep({ formData, handleInputChange, handleComplete, isReadOnly }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleSubmit = async () => {
    if (!formData.detailsDeclaration || !formData.policiesDeclaration) {
      return;
    }

    // Show confirmation dialog first
    setShowConfirmation(true);
  };

  const confirmSubmission = async () => {
    setIsSubmitting(true);
    setApiError(null);
    
    try {
      // Get auth details from localStorage
      const auth_key = localStorage.getItem('authKey');
      const user_id = localStorage.getItem('userId');

      if (!auth_key || !user_id) {
        throw new Error('Authentication credentials not found. Please log in again.');
      }

      // Prepare the payload - similar to the pattern in BankStep.js
      const payload = {
        detailsDeclaration: formData.detailsDeclaration,
        policiesDeclaration: formData.policiesDeclaration,
        auth_key,
        user_id
      };

      // Send to API
      const response = await fetch(`${API_BASE_URL}/brands/onboarding/declaration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }

      // If successful, complete the onboarding process
      if (handleComplete) {
        handleComplete();
      }
      
      // Reload the page to refresh the data
      window.location.reload();
    } catch (error) {
      setApiError(error.message);
    } finally {
      setIsSubmitting(false);
      setShowConfirmation(false);
    }
  };

  const cancelSubmission = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="onboarding-section declaration">
      <div className="declaration-container">
        <h1 className="section-title">Declaration</h1>

        {apiError && (
          <div className="api-error-message">
            {apiError}
          </div>
        )}

        <div className="pdf-container" style={{ width: '100%', height: '400px', marginBottom: '20px' }}>
          <iframe
            src="https://polopanmerchants.blob.core.windows.net/brands/agreement-polopan.pdf"
            width="100%"
            height="100%"
            title="PoloPan Agreement"
            style={{ border: '1px solid #ccc' }}
          ></iframe>
        </div>

        <div className="declaration-form">
          <div className="declaration-item">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="detailsDeclaration"
                checked={formData.detailsDeclaration}
                onChange={(e) => handleInputChange({
                  target: {
                    name: e.target.name,
                    value: e.target.checked
                  }
                })}
                disabled={isReadOnly}
              />
              <span className="checkbox-text">
                I hereby declare that the details furnished are true and correct. I undertake to inform you of any changes therein: immediately
              </span>
            </label>
          </div>

          <div className="declaration-item">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="policiesDeclaration"
                checked={formData.policiesDeclaration}
                onChange={(e) => handleInputChange({
                  target: {
                    name: e.target.name,
                    value: e.target.checked
                  }
                })}
                disabled={isReadOnly}
              />
              <span className="checkbox-text">
                I hereby declare that I will comply with all PoloPan policies on ethics and compliance.
              </span>
            </label>
          </div>

          {!isReadOnly && (
            <div className="form-actions">
              <div className="navigation-buttons">
                <button 
                  className="submit-button"
                  disabled={!formData.detailsDeclaration || !formData.policiesDeclaration || isSubmitting || isReadOnly}
                  onClick={handleSubmit}
                >
                  {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="confirmation-modal" style={{
            width: '90%',
            maxWidth: '500px',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }}>
            <h3 style={{ marginTop: 0 }}>Confirm Submission</h3>
            <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
              Important: All form entries will be locked once submitted.
            </p>
            <p>
              You will not be able to make changes to any of your submitted information after proceeding. 
              Please ensure all details are accurate before confirming.
            </p>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '20px'
            }}>
              <button 
                onClick={cancelSubmission}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button 
                onClick={confirmSubmission}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: '#d32f2f',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                Confirm & Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeclarationStep; 